import { combineReducers } from "redux";
// import visibilityFilter from "./visibilityFilter";
import mainState from "./reducers";
// let reducer = function(state,action){
//     return state || {};
// }
export default combineReducers({ mainState });
